import { render, staticRenderFns } from "./IncidentManagement.vue?vue&type=template&id=730bf0a2&scoped=true"
import script from "./IncidentManagement.vue?vue&type=script&lang=js"
export * from "./IncidentManagement.vue?vue&type=script&lang=js"
import style0 from "./IncidentManagement.vue?vue&type=style&index=0&id=730bf0a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730bf0a2",
  null
  
)

export default component.exports